import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './Imageslider.css';

import { validateImageURLString } from '../../utils/utils';

const ImageSlider = (props) => {
  const { option } = props;

  const images1 = [];

  let toChangeArray = new Array();

  toChangeArray = option?.images?.split(',');

  let customImages = [];

  if (toChangeArray?.length > 0) {
    customImages = toChangeArray?.filter((url, index) => {
      return validateImageURLString(url);
    });
  }

  if (option && customImages?.length > 0) {
    if (option.floorPlan) {
      customImages = customImages.filter((img) => img !== option.floorPlan);
    }

    customImages.map((image) =>
      images1.push({
        original: encodeURI(image),
        thumbnail: encodeURI(image),
      }),
    );
  }

  const renderFullscreenButton = (onClick, isFullscreen) => {
    return (
      <button
        type="button"
        className={`image-gallery-fullscreen-button${isFullscreen ? ' active' : ''}`}
        onClick={onClick}
      />
    );
  };
  const _renderCustomControls = () => {
    return (
      <a href="" className="image-gallery-custom-action" onClick={this._customAction.bind(this)} />
    );
  };

  return (
    <div id="option__detail">
      {images1 && images1?.length > 0 && (
        <div className="imgPanel">
          <ImageGallery items={images1} showPlayButton={false} showFullscreenButton={false} />
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
